import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';
import { inviteParentUtilityStateAtom } from './InviteParentUtility.state';

export function useInviteParentUtility() {
  const setInviteState = useSetRecoilState(inviteParentUtilityStateAtom);

  const openInviteParentUtility = useCallback(() => {
    setInviteState({ open: true });
  }, [setInviteState]);

  const closeInviteParentUtility = useCallback(() => {
    setInviteState({ open: false });
    requestAnimationFrame(() => {
      if (
        document.activeElement &&
        typeof document.activeElement.blur === 'function'
      ) {
        document.activeElement.blur();
      }
    });
  }, [setInviteState]);

  return {
    openInviteParentUtility,
    closeInviteParentUtility,
  };
}
